import { RouteRecordRaw, RouterView } from 'vue-router'
import Page from '../components/Page.vue';
import SplashPage from '../components/pages/SplashPage.vue';
import LevelSelectPage from '../components/pages/LevelSelectPage.vue';
import LevelSelectPlayPage from '../components/pages/LevelSelectPlayPage.vue';
import ReportCardPage from '../components/pages/ReportCardPage.vue';
import requireAuth from './guards/requireAuth';
import multiguard from 'vue-router-multiguard';
import requireTeam from './guards/requireTeam';
import fetchCompetition from './guards/fetchCompetition';
import requireCybersafeCompetition from './guards/requireCybersafeCompetition';
import { h } from 'vue';
import injectSubdomainAsRouteParam from './guards/injectSubdomainAsRouteParam';
import showInitialLoading from './guards/showInitialLoad';
import logout from './guards/logout';
import redirectToLevelSelectIfSso from './guards/redirectToLevelSelectIfSso';
import fetchScore from './guards/fetchScore';
import ssoRedirect from './guards/ssoRedirect';
import skipSsoForUscr from './guards/skipSsoForUscr';

// Shell component used to group routes together. 
// Helpful for grouping child routes without including the splash page.
const GuardedGroup =
{
    render()
    {
        return h(RouterView);
    }
}

class Route
{
    static Splash      = { name: 'splash',        path: '/',             component: SplashPage }
    static Logout      = { name: 'logout',        path: '/logout' }
    static LevelSelect = { name: 'mission-select',  path: '/mission-select', component: LevelSelectPage }
    static LevelSelectPlay = { name: 'mission-select-play',  path: '/mission-select/:mission/play', component: LevelSelectPlayPage } // Path DOES support direct navigation to mission
    static ReportCard = { name: 'mission-log',  path: '/mission-log/:reportCardId', component: ReportCardPage, props: true }

    static SsoCourseware = { name: 'sso-courseware', path: '/sso/courseware' }
    static SsoContactSupport = { name: 'sso-contact-support', path: '/sso/contact-support' }

    static toRouteRecordRaw():RouteRecordRaw[]
    {
        let routes:RouteRecordRaw[] = [
            {
                path: '/',
                component: Page,
                children: [
                    { ...Route.Splash, 
                        beforeEnter: redirectToLevelSelectIfSso },
                    {
                        ...Route.Logout,
                        component: SplashPage,
                        beforeEnter: logout
                    },
                    { ...Route.ReportCard },
                    {
                        ...Route.SsoCourseware,
                        component: SplashPage,
                        beforeEnter: multiguard([requireAuth, ssoRedirect]),
                        meta: { ssoTargetKey: 'CYBERSAFE_AI_COURSEWARE_URL' }
                    },
                    {
                        ...Route.SsoContactSupport,
                        component: SplashPage,
                        beforeEnter: multiguard([requireAuth, skipSsoForUscr, ssoRedirect]),
                        meta: { ssoTargetKey: 'SUPPORT_URL' }
                    },
                    {
                        path: '',
                        component: GuardedGroup,
                        // Fetch competition second time to get full view based on claims.
                        beforeEnter: multiguard([showInitialLoading, injectSubdomainAsRouteParam, fetchCompetition, requireCybersafeCompetition, requireAuth, fetchCompetition, requireTeam, fetchScore]),
                        children: [
                            { ...Route.LevelSelect },
                            { ...Route.LevelSelectPlay },
                        ]
                    },

                ]
            },
            // Legacy URLs (pre Level->Mission and Report Card->Mission Log rename). Params and query are preserved.
            { path: '/level-select', redirect: { name: Route.LevelSelect.name } },
            { path: '/level-select/:mission/play', redirect: { name: Route.LevelSelectPlay.name } },
            { path: '/report-card/:reportCardId', redirect: { name: Route.ReportCard.name } },
            { path: "/:catchAll(.*)", redirect: Route.Splash }
        ]

        /**
         * Set route.meta.title to route.name. 
         * The value is NOT for web browsers but for analytics.
         * For web browser's page title, see src/composables/usePageTitle.ts
         */
        const setRouteMetaTitle = (route:RouteRecordRaw) =>
        {
            route.meta ??= {};

            route.meta.title = route.meta.title || route.name;

            route.children?.forEach(setRouteMetaTitle);
        }

        routes.forEach(setRouteMetaTitle);

        return routes;
    }
}
export default Route
